import React from 'react'
import IconAndTextBlock from 'redesign/components/molecules/IconAndTextBlock'
import ActionWrapper from './action-wrapper'
import { MenuItem } from './styles'
import type { ActionButtonProps, ActionIcon } from './types'

const ActionMenuItem: React.FC<ActionButtonProps> = ({
  icon,
  label,
  color,
  hiddenActions = [],
  onClick,
  testId,
  anchorEl,
  isMenuOpen,
  setIsMenuOpen,
  disabled,
}) => {
  const Icon = icon as ActionIcon

  return (
    <ActionWrapper
      isMenuOpen={isMenuOpen}
      setIsMenuOpen={setIsMenuOpen}
      anchorEl={anchorEl}
      hiddenActions={hiddenActions}
    >
      <MenuItem
        disabled={disabled}
        data-testid={testId}
        onClick={onClick as unknown as React.MouseEventHandler<HTMLLIElement>}
      >
        <IconAndTextBlock icon={Icon} title={label} titleColor={color} variant="body1" />
      </MenuItem>
    </ActionWrapper>
  )
}

export default ActionMenuItem
